module.exports = __webpack_public_path__ + "static/media/Invitation2021.e9d6fc80.png";